import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TermsAndConditions from '../components/termsAndConditions/TermsAndConditions';
import '../stylesheets/stylesPopUp/termsAndConditionsPopUp.scss';
import useTranslate from '../customHooks/useTranslate';

const TermsAndConditionsViewPopUp = props => {
    const { isOpenPopUp, setIsOpenPopUp } = props;

    const translate = useTranslate();

    const handleClose = () => {
        setIsOpenPopUp(false);
    };

    return (
        <>
            {isOpenPopUp && (
                <div className='container__popup--view'>
                    <Dialog
                        open={isOpenPopUp}
                        onClose={handleClose}
                        aria-labelledby='terms-and-conditions-view-title'
                        maxWidth='lg'
                        className='container__popup--custom__dialog'
                    >
                        <DialogTitle id='terms-and-conditions-view-title'>
                            {translate('title_view_terms_conditions')}
                            <IconButton
                                aria-label='close'
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 14,
                                    top: 14,
                                    color: theme => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent className='dialog__content'>
                            <TermsAndConditions />
                        </DialogContent>
                        <DialogActions
                            classes={{
                                root: 'dialog__footer dialog__footer--right',
                            }}
                        >
                            <Button
                                size='small'
                                variant='contained'
                                className='accept__button'
                                onClick={handleClose}
                            >
                                {translate('close')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    );
};

export default TermsAndConditionsViewPopUp;
